require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./banques-1-1-18-5.json") })
        }
      }, "path---banques-1-1-18-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---banques-1-1-18-5!./.cache/json/banques-1-1-18-5.json
// module id = 346
// module chunks = 231608221292675